import {Component, Input, QueryList, ViewChildren, OnInit, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import {AsyncPipe, CommonModule, DecimalPipe} from "@angular/common";
import {BarRatingModule} from "ngx-bar-rating";
import {CommonSvgIconsComponent} from "../common-svg-icons/common-svg-icons.component";
import {FormsModule} from "@angular/forms";
import {NgbModal, NgbPagination, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {ProductHeaderComponent} from "../../../components/product-list/product-header/product-header.component";
import {ProductListDirective, SortEvent} from "../../../components/product-list/product-list.directive";
import {HeaderComponent} from "./header/header.component";
import {Observable} from "rxjs";
import {TableService} from "../../../core/services/table.service";
import {ConfirmComponent} from "./modals/confirm/confirm.component";
import {GeneralService} from "../../../core/services/general.service";
import {AddComponent} from "./modals/add/add.component";
import {FeatherIconsComponent} from "../feather-icons/feather-icons.component";

@Component({
    selector: 'app-table-modal',
    standalone: true,
    imports: [
        AsyncPipe,
        BarRatingModule,
        CommonSvgIconsComponent,
        FormsModule,
        NgbPagination,
        ProductHeaderComponent,
        ProductListDirective,
        HeaderComponent,
        CommonModule,
        FeatherIconsComponent,
        NgbTooltip
    ], providers:[DecimalPipe, TableService],
    templateUrl: './table.component.html',
    styleUrl: './table.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class TableModalComponent implements OnInit{

    @Input() configurationTable: any;

    public dataTable$: Observable<any[]>;
    public dataTable: any[] = [];
    public total$: Observable<number>;
    @ViewChildren(ProductListDirective)
    public headers: QueryList<ProductListDirective>;
    columns:any[] = [];

    constructor(public service: TableService, private modalService: NgbModal, private generalService: GeneralService, private cdr: ChangeDetectorRef) {
        this.dataTable$ = service.getList$;
        this.total$ = service.total$;
    }

    ngOnInit() {
        this.dataTable = [];
        this.columns = this.configurationTable.columns.filter((item: any) => !item['onlyForm']);
        this.cdr.detectChanges();
        this.service.generateData(this.configurationTable);
        this.service.searchTerm = "";
        this.service.getList$.subscribe((data: any) => {
            if (data) {
                this.dataTable = data;
            }
        });
    }

    //Función para ejecutar acciones de la tabla
    executeAction(action: any, row: any): void {
        // Lógica para procesar la acción
        switch (action.type) {
            case"delete":
                let modal = this.modalService.open(ConfirmComponent, { centered: true });
                modal.componentInstance.data = {action: this.configurationTable.config, row}
                modal.componentInstance.confirmAction = (data: any) => {
                    this.reloadTable();
                };
                break;
            case"update":
                let modalAdd = this.modalService.open(AddComponent, { centered: true, windowClass: 'modal-xl'});
                modalAdd.componentInstance.title = "Editar "+this.configurationTable.title;
                modalAdd.componentInstance.columns = this.configurationTable.columns;
                modalAdd.componentInstance.data = {action: this.configurationTable.config, row};
                modalAdd.componentInstance.confirmAction = () => {
                    this.reloadTable();
                };
                break;
            case"emmit":
                action.fn(row);
                break;
            default:
                this.generalService.showMessage('warn', 'Error!. ' + "Acción no controlada");
                break;
        }
        if (action.type === 'update') {
            row[action.id] = action.value; // Simulación de actualización
        }
    }

    //Función para recargar tabla
    reloadTable(filter: any[] = []){
        this.configurationTable.filters = filter;
        this.service.generateData(this.configurationTable);
    }
}
